<template>
  <div class="f-wrap">
    <h5>主讲人</h5>
    <div class="table">
      <div class="avatar">
        <img v-lazy="data.icon" alt="">
      </div>
      <div class="info">
        <p class="name">{{data.name}}</p>
        <p class="honor">{{data.honor}}</p>
      </div>
      <div class="follow" :class="{ed: this.follow}" @click="f">{{this.follow?'已关注':'+关注'}}</div>
    </div>
    <qr-popup class="qr-popup" :show="showQrPopup" :img="qrurl" :text="qrtext"></qr-popup>
  </div>
</template>

<script>
import {followDaka, unfollowDaka} from '@/api/user-behavior.js'
import {RES_OK} from '@/api/config'
import QrPopup from 'components/base/qr-popup'
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}) // 空对象
    }
  },
  data() {
    return {
      following: false,
      follow: false,
      // 关注大咖操作二维码弹框
      showQrPopup: false,
      qrurl: '',
      qrtext: ''
    }
  },
  created() {
    this.follow = this.data.is_follow
  },
  methods: {
    f() {
      if (!this.following) {
        this.following = true
        const cb = res => {
          const data = res.data
          if (data && data.code === RES_OK) {
            if (this.follow) {
              this.$toast('取消关注成功')
              this.showQrPopup = false
            } else {
              this.$toast('关注成功')
              if (data.data.qrurl) {
                console.log('弹出关注二维码')
                this.qrurl = data.data.qrurl
                this.qrtext = '关注公众号, 不会错过老师上新课程'
                this.showQrPopup = true
              }
              console.log(data.data)
            }
            this.follow = !this.follow
          } else if (data && data.msg) {
            // 打印错误信息
            console.log(data.msg)
          }
          this.following = false
        }
        if (this.follow) {
          // 已关注状态,就取消关注
          unfollowDaka(this.data.teacher_id).then(cb)
        } else {
          // 未关注,现在就关注
          followDaka(this.data.teacher_id).then(cb)
        }
      }
    }
  },
  components: {
    QrPopup
  }
}
</script>

<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .f-wrap
    padding 0 size(30) size(40)
  h5
    font-size size(34)
    line-height size(108)
  .table
    display flex
    height size(100)
    align-items center
    .avatar
      width size(100)
      height size(100)
      overflow hidden
      img
        width 100%
        display block
    .info
      flex 1
      padding-left size(22)
    .name
      font-size size(32)
      font-weight 800
    .honor
      margin-top  size(16)
      font-size size(24)
      color #999
      word-wrap break-word
      word-break break-all
      overflow hidden
      text-overflow ellipsis
      display -webkit-box
      -webkit-line-clamp 1
      -webkit-box-orient vertical
    .follow
      margin-left size(24)
      font-size size(24)
      color $color-theme
      min-width size(112)
      line-height size(48)
      height size(48)
      background lighten($color-theme, 90%)
      text-align center
      border-radius size(24)
      &.ed
        background #efefef
        color #afafaf
  .qr-popup{
    position relative
    z-index 1000
  }
</style>



// WEBPACK FOOTER //
// src/components/base/ui/teacher.vue